export default __webpack_public_path__ + "static/media/about-light.b5da39b1.svg";